import moment from 'moment';

export default class SimulationReportChartData {
  constructor(data) {
    this.Options = data.Options || null;
    this.DecisionMakerId = data.DecisionMakerId || null;
    this.TickerData = data.TickerData ?
      data.TickerData.map(tickerData => new TickerChartData(tickerData)) :
      [];
  }
}

export class TickerChartData {
  constructor(data) {
    this.TickerId = data.TickerId;
    this.TickerCode = data.TickerCode;
    this.TickerName = data.TickerName;

    // Convert notifications array to StoredEvent instances with proper timestamp handling
    this.Notifications = data.Notifications ?
      data.Notifications.map(notification => new StoredEvent(notification)) :
      [];

    // Convert trades array to BotTrade instances with proper timestamp handling
    this.Trades = data.Trades ?
      data.Trades.map(trade => new BotTrade(trade)) :
      [];
  }
}

export class StoredEvent {
  constructor(data) {
    this.Source = data.Source;
    this.Type = data.Type;
    this.Message = data.Message;
    this.TriggeredCandleId = data.TriggeredCandleId;
    this.TickerId = data.TickerId;

    // Handle Time field with moment.js - same pattern as other entities
    if (data.Time !== undefined) {
      this.Time = (data.Time === null) ? null : moment.utc(data.Time);
    }

    // Handle TriggeredCandleTime field with moment.js
    if (data.TriggeredCandleTime !== undefined) {
      this.TriggeredCandleTime = (data.TriggeredCandleTime === null) ? null : moment.utc(data.TriggeredCandleTime);
    }
  }

  // Return formatted local time string for display
  getTime() {
    return this.Time ? this.Time.local().format('L LTS') : '';
  }

  // Return formatted triggered candle time for display
  getTriggeredCandleTime() {
    return this.TriggeredCandleTime ? this.TriggeredCandleTime.local().format('L LTS') : '-';
  }

  // Get ticker display - return TickerId or dash if not available
  getTickerDisplay() {
    return this.TickerId || '-';
  }

  // Get type display
  getTypeDisplay() {
    return this.Type || '-';
  }

  // Get message display
  getMessageDisplay() {
    return this.Message || '';
  }
}

export class BotTrade {
  constructor(data) {
    this.Id = data.Id;
    this.TickerId = data.TickerId;
    this.TradingDayId = data.TradingDayId;
    this.TradeProgramId = data.TradeProgramId;
    this.BasedOnOrderbookId = data.BasedOnOrderbookId;
    this.CalculatedPrice = data.CalculatedPrice;
    this.ActualPrice = data.ActualPrice;
    this.Quantity = data.Quantity;
    this.TotalAmount = data.TotalAmount;
    this.Comission = data.Comission;
    this.Type = data.Type;

    // Handle timestamp fields with moment.js
    if (data.CreateTime !== undefined) {
      this.CreateTime = (data.CreateTime === null) ? null : moment.utc(data.CreateTime);
    }

    if (data.UpdateTime !== undefined) {
      this.UpdateTime = (data.UpdateTime === null) ? null : moment.utc(data.UpdateTime);
    }

    if (data.Time !== undefined) {
      this.Time = (data.Time === null) ? null : moment.utc(data.Time);
    }
  }

  // Return formatted local time strings for display
  getCreateTime() {
    return this.CreateTime ? this.CreateTime.local().format('L LTS') : '';
  }

  getUpdateTime() {
    return this.UpdateTime ? this.UpdateTime.local().format('L LTS') : '';
  }

  getTime() {
    return this.Time ? this.Time.local().format('L LTS') : '';
  }

  // Get trade type display
  getTradeTypeDisplay() {
    const action = this.Quantity > 0 ? 'BUY' : 'SELL';
    return `${this.Type} ${action}`;
  }

  // Format price for display
  getFormattedPrice() {
    return this.ActualPrice ? `$${this.ActualPrice.toFixed(2)}` : '';
  }

  // Format total amount for display
  getFormattedAmount() {
    return this.TotalAmount ? `$${this.TotalAmount.toFixed(2)}` : '';
  }

  // Format commission for display
  getFormattedCommission() {
    return this.Comission ? `$${this.Comission.toFixed(2)}` : '';
  }

  // Get absolute quantity for display
  getAbsoluteQuantity() {
    return Math.abs(this.Quantity || 0);
  }
}